/**
 * Safe `Node.contains` — event targets / relatedTarget can be `window`, `null`,
 * or cross-realm objects (extensions, iframes), which make `contains()` throw.
 */
export function isDomNode(value: unknown): value is Node {
  return typeof Node !== 'undefined' && value instanceof Node
}

export function containsTarget(container: Node | null | undefined, target: unknown): boolean {
  if (!container || !isDomNode(target)) return false
  return container.contains(target)
}
